module.exports = __webpack_public_path__ + "img/product18.c7dd1474.png";